import {CONTENT_TYPE_TEXT, CONTENT_CATEGORY_PROJECT} from '../../constants';

export default {
  id: 'DELETE_FROM_OPER',
  title: 'Come posso eliminare un\'azienda da un\'operazione?',
  description: '',
  categories: [CONTENT_CATEGORY_PROJECT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Per rimuovere un\'azienda da un\'operazione, puoi presentare la tua richiesta al Servizio Clienti specificando il nome dell\'operazione, la ragione sociale e il Codice Fiscale  dell\' impresa da eliminare.'
  }]
};
